import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.2512 2.2512)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M19.5 9.75C19.5 12.3359 18.473 14.8161 16.6445 16.6445C14.8161 18.473 12.3359 19.5 9.75 19.5H9.74707C7.03752 19.4898 4.43638 18.4321 2.48828 16.5488L1.5 15.5605V18.75H0V13.75C0 13.3358 0.335786 13 0.75 13H5.75V14.5H2.56055L3.53125 15.4707C5.20062 17.0845 7.42914 17.9898 9.75098 17.999C11.9387 17.9988 14.037 17.1309 15.584 15.584C17.1312 14.0368 18 11.938 18 9.75H19.5ZM10.2598 0.0136719C12.6168 0.136421 14.8646 1.05064 16.6387 2.60742L17.0117 2.95117L18 3.93945V0.75H19.5V5.75C19.5 6.16421 19.1642 6.5 18.75 6.5H13.75V5H16.9395L15.9688 4.0293L15.6494 3.73535C14.0203 2.30565 11.9252 1.5084 9.74805 1.5C7.56071 1.50052 5.46273 2.3693 3.91602 3.91602C2.36884 5.46319 1.5 7.56196 1.5 9.75H0C0 7.16414 1.02699 4.68395 2.85547 2.85547C4.68395 1.02699 7.16414 0 9.75 0H9.75293L10.2598 0.0136719Z",
			fill: "currentColor"
		})
	})
});
export default SvgRefresh;
